<template>
  <div class="autocomplete-input">
    <span
      v-if="title"
      class="autocomplete-input__title"
    >
      {{ title }}
    </span>
    <v-autocomplete
      ref="autocomplete"
      v-bind:class="{ 'mis-style': styleMis }"
      v-bind:label="label"
      data-lpignore="true"
      hide-details="auto"
      v-bind:attach="attach"
      v-bind:item-text="itemText"
      v-bind:item-value="itemValue"
      v-bind:multiple="multiple"
      v-bind:clearable="clearable"
      v-bind:no-filter="disableSearch"
      v-bind:placeholder="placeholder"
      :menu-props="menuProps"
      name="category"
      v-bind:items="items"
      v-bind:loading="loading"
      v-bind:hide-no-data="loading"
      v-on:update:search-input="onUpdateSearch"
      v-on="listeners"
      v-bind="$attrs">
      <template v-slot:item="slotProps">
        <v-list-item
          v-bind="slotProps.attrs"
          v-on="slotProps.on"
          class="autocomplete-item"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ slotProps.item[itemText] }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action
            v-if="canDeleteItems && slotProps.item[itemValue] !== 'new'"
            class="delete-action"
          >
            <v-icon
              small
              color="red"
              v-on:click.stop="onDeleteItem(slotProps.item[itemValue])"
            >
              mdi-close
            </v-icon>
          </v-list-item-action>
        </v-list-item>
      </template>
      <template v-slot:append-item>
        <button
          class="custom-item"
          type="button"
          v-on:click="handleCustomItemClick"
          v-if="isShowCustomItem"
        >
          {{ customItem[itemText] }}
        </button>
      </template>
      <template v-slot:no-data>
        <slot name="no-data">
          <p class="no-data">Результатов нет</p>
        </slot>
      </template>
    </v-autocomplete>
    <p
      class="text__violation"
      role="alert"
      v-for="error in violations"
      v-bind:key="error"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'AutocompleteInput',
  computed: {
    listeners() {
      const { 'update:search-input': _, ...listeners } = this.$listeners;
      return listeners;
    },
    /**
     * Показывать ли особый компонент
     *
     * @return {{bool}}
     */
    isShowCustomItem() {
      return this.customItem !== null;
    },
  },
  methods: {
    /**
     * @description Обработать событие обновления строки поиска.
     * @returns {void}
     */
    onUpdateSearch(event) {
      if (this.keepSearchOnBlur && !event) {
        if (!this.$refs.autocomplete) {
          return;
        }
        if (!this.$refs.autocomplete.isFocused) {
          const currentSearch = this.$attrs['search-input'] || this.$attrs.searchInput;
          if (currentSearch) {
            this.$refs.autocomplete.internalSearch = currentSearch;
            return;
          }
        }
      }
      this.$emit('search-input', event);
      this.$emit('update:search-input', event);
    },
    /**
     * @description Прослушивать событие клика на кастомном элементе.
     * @returns {void}
     */
    handleCustomItemClick() {
      this.$emit('custom-item-click');
    },
    /**
     * @description Обработать событие удаления элемента.
     * @param {number} value
     * @returns {void}
     */
    onDeleteItem(value) {
      this.$emit('delete-item', value);
    },
  },
  props: {
    /**
     * @description Выключить поиск
     * @type {Boolean}
     */
    disableSearch: {
      default: false,
      type: Boolean,
    },
    /**
     * @description К какому элементу прикреплять dropdown.
     * @type {Element|boolean}
     */
    attach: {
      default: () => true,
      type: [Element, Boolean],
    },
    styleMis: {
      default: () => false,
      type: Boolean,
    },
    title: {
      default: () => '',
      type: String,
    },
    label: {
      default: () => '',
      type: String,
    },
    itemValue: {
      default: () => 'value',
      type: String,
    },
    itemText: {
      default: () => 'text',
      type: String,
    },
    items: {
      required: true,
      type: Array,
    },
    /**
     * @description Ошибки.
     */
    violations: {
      default: () => [],
      type: Array,
    },
    multiple: {
      default: () => false,
      type: Boolean,
    },
    menuProps: {
      default: () => {},
      type: Object,
    },
    clearable: {
      default: () => false,
      type: Boolean,
    },
    customItem: {
      default: null,
      type: Object,
    },
    canDeleteItems: {
      default: false,
      type: Boolean,
    },
    loading: { default: false, type: Boolean },
    placeholder: { default: '', type: String },
    keepSearchOnBlur: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
  .autocomplete-input {
    &__title {
      display: block;
      margin-bottom: 3px;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: var(--unfocus-color);
    }
  }
  .autocomplete-item {
    .delete-action {
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    &:hover .delete-action {
      opacity: 1;
    }
  }
  .custom-item {
    padding-inline: 16px;
    padding-block: 12px;
    text-align: left;
  }
  .no-data {
    padding: 10px;
    margin: 0;
  }
  .mis-style.v-text-field--solo {
    ::v-deep {
      .v-input__control {
        min-height: 40px;
        > .v-input__slot {
          padding-inline: 10px;
          border-radius: var(--input-border-radius);
          border: 1px solid var(--border-color);
          box-shadow: none !important;
        }
      }
      .v-label {
        color: var(--placeholder-color);
      }
    }
  }
  .multiline::v-deep .v-list-item__title {
    white-space: normal !important;
  }
  ::v-deep .v-text-field {
    .v-input__icon .mdi-menu-down::before {
      content: "";
      width: 14px;
      height: 8px;
      background: url("@/assets/img/checked/checked-grey.svg") 50%;
      background-size: contain;
      cursor: pointer;
    }
  }
  .text-small {
    .v-list {
      ::v-deep .v-list-item {
        min-height: 44px;
        &__content {
          padding-block: 10px;
        }
        &__title {
          font-size: 14px !important;
        }
      }
    }
  }
  .text-big {
    .v-list {
      ::v-deep .v-list-item {
        min-height: 44px;
        &__content {
          padding-block: 12px;
        }
        &__title {
          font-size: 16px !important;
          font-weight: 400;
        }
      }
    }
  }
  .text__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: 0.125rem;
  }
</style>
